import useMutationCall from "../../../hooks/useMutationCall";
import { useDeclineOfferMutation } from "../offersSlice";

const useOfferDecline = () => {
  return useMutationCall(useDeclineOfferMutation);
};

export default useOfferDecline;
